// extracted by mini-css-extract-plugin
module.exports = {"canvasBox":"PhotoPickerDialog_canvasBox__3pRMp","uploadOverlay":"PhotoPickerDialog_uploadOverlay__2FNEj"};